/**
 * /dashboard/expenses/new — File-an-expense form (Phase 3d).
 *
 * Pattern B per docs/19-FRONTEND-UI-PATTERNS.md — a dedicated route for
 * a form with 5+ inputs + category-rule hint. Do NOT modal-ize.
 *
 * Migration note: port of
 * frontend/src/app/(dashboard)/dashboard/expenses/new/page.tsx.
 *   - "use client" dropped
 *   - next/link → @tanstack/react-router Link
 */

import { createFileRoute } from "@tanstack/react-router";
import { ExpensesModuleShell } from "@/components/shared/expenses-module-shell";
import { ExpenseFeatureGate } from "@/components/expenses/expense-feature-gate";
import { ExpenseForm } from "@/components/expenses/expense-form";
import { Card, CardContent } from "@/components/ui/card";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/expenses/new",
)({
  component: NewExpenseRoute,
});

function NewExpenseRoute() {
  // Top-of-page Back button removed per Audit 4 Quick-Win #4 — the
  // bottom Cancel button (right-aligned per Quick-Win #3) does the
  // same job inside the action row, where the user already is.
  return (
    <ExpensesModuleShell
      title="New expense"
      description="File an expense claim. Receipts are attached after saving a draft."
    >
      <ExpenseFeatureGate>
        <Card>
          <CardContent className="py-6">
            <ExpenseForm />
          </CardContent>
        </Card>
      </ExpenseFeatureGate>
    </ExpensesModuleShell>
  );
}
